import React from 'react';
import { Box, Typography } from '@mui/material';
import ProdutoForm from '../components/produto/ProdutoForm';

const ProdutoEditar: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Editar Produto
      </Typography>
      <ProdutoForm isEdit />
    </Box>
  );
};

export default ProdutoEditar;
